/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S5_Written_LinkInputs */

const tr_hakkimizda_s5_written_link = /** @type {(inputs: Hakkimizda_S5_Written_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iletişim`)
};

const en_hakkimizda_s5_written_link = /** @type {(inputs: Hakkimizda_S5_Written_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact`)
};

const de_hakkimizda_s5_written_link = /** @type {(inputs: Hakkimizda_S5_Written_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_hakkimizda_s5_written_link = /** @type {(inputs: Hakkimizda_S5_Written_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

/**
* | output |
* | --- |
* | "contact" |
*
* @param {Hakkimizda_S5_Written_LinkInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s5_written_link = /** @type {((inputs?: Hakkimizda_S5_Written_LinkInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S5_Written_LinkInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s5_written_link(inputs)
	if (locale === "de") return de_hakkimizda_s5_written_link(inputs)
	if (locale === "ru") return ru_hakkimizda_s5_written_link(inputs)
	return tr_hakkimizda_s5_written_link(inputs)
});